<template>
  <div class="contact-conversation--panel">
    <div class="contact-conversation__wrap">
      <div v-if="!previousConversations.length" class="no-label-message">
        <span>
          {{ $t('CONTACT_PANEL.CONVERSATIONS.NO_RECORDS_FOUND') }}
        </span>
      </div>
      <div v-else class="contact-conversation--list">
        <conversation-card
          v-for="conversation in previousConversations"
          :key="conversation.id"
          :chat="conversation"
          :hide-inbox-name="false"
          :hide-thumbnail="true"
          class="compact"
        />
      </div>
      <div class="previous-footer ">
        <table-footer
          v-if="totalCount"
          :current-page="Number(meta.currentPage)"
          :total-count="totalCount"
          :page-size="20"
          :is-info-visible="false"
          @page-change="onPageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ConversationCard from 'dashboard/components/widgets/conversation/ConversationCard';
import { mapGetters } from 'vuex';
import TableFooter from 'dashboard/components/widgets/TableFooter';

export default {
  components: {
    ConversationCard,
    TableFooter,
  },
  props: {
    contactId: {
      type: [String, Number],
      required: true,
    },
    conversationId: {
      type: [String, Number],
      required: true,
    },
  },
  computed: {
    totalCount() {
      return Number(this.meta.count) - 1;
    },
    conversations() {
      return this.$store.getters['contactConversations/getContactConversation'](
        this.contactId
      );
    },
    previousConversations() {
      return this.conversations.filter(
        conversation => conversation.id !== Number(this.conversationId)
      );
    },
    ...mapGetters({
      uiFlags: 'contactConversations/getUIFlags',
      meta: 'contactConversations/getMeta',
    }),
  },
  watch: {
    contactId(newContactId, prevContactId) {
      if (newContactId && newContactId !== prevContactId) {
        this.fetchContactConversations(newContactId, 1);
      }
    },
  },
  mounted() {
    this.fetchContactConversations(this.contactId, 1);
  },
  methods: {
    onPageChange(page) {
      this.fetchContactConversations(this.contactId, page);
    },
    fetchContactConversations(contactId, page) {
      this.$store.dispatch('contactConversations/get', {
        contactId,
        page,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.contact-conversation--panel {
  border: 1px solid var(--b-100);
  border-radius: 8px;
  overflow: hidden;
}

.no-label-message {
  color: var(--b-500);
  padding: 0.6rem;
  text-align: center;
}

::v-deep .conversation {
  padding-right: 0;
  .conversation--details {
    padding-left: var(--space-small);
  }
}
.previous-footer {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
